export default {
    pmFromPmWarning:
        'The /pm command is not supported while in a private message.',
    pmWarningIfNotPremium:
        'Private messages to models may only be sent by Premium Members. Please buy tokens to become a Premium Member forever. Please note that some models might opt to befriend you before they can accept your private messages even as a Premium member',
    pmWithoutUsername: 'You must include a username.',
    tipCommandWithoutPermission:
        'The /tip command is only available to Premium Members. Please buy tokens one time to become a premium member forever.',
    quickbuyCommandWithoutPermission:
        'The /quickbuy command is only available to Premium Members. Please buy tokens one time to become a premium member forever.',
    whisperFromPmWarning:
        'The /whisper command is not supported while in a private message.',
}
